<template>
    <div class="roleplayer">
        <Navbar />
        <v-content>
            <v-container grid-list-md>
                <v-layout row wrap>
                    <v-flex xs12 md3 v-if="roleplayer.name">
                        <h3>Name</h3>
                        <p>{{roleplayer.name}}</p>
                    </v-flex>
                    <v-flex xs12 md3 v-if="roleplayer.prename">
                        <h3>Prename</h3>
                        <p>{{roleplayer.prename}}</p>
                    </v-flex>
                    <v-flex xs12 md1 v-if="roleplayer.age">
                        <h3>Age</h3>
                        <p>{{roleplayer.age}}</p>
                    </v-flex>
                    <v-flex xs12 md2 v-if="roleplayer.gender">
                        <h3>Gender</h3>
                        <p>{{roleplayer.gender}}</p>
                    </v-flex>
                    <v-flex xs12 md3 v-if="roleplayer.nationality">
                        <h3>Nationality</h3>
                        <p>{{roleplayer.nationality}}</p>
                    </v-flex>
                    <v-flex xs12 md3 v-if="roleplayer.passport">
                        <h3>Passport/ID No.</h3>
                        <p>{{roleplayer.passport}}</p>
                    </v-flex>
                    <v-flex xs12 md3 v-if="roleplayer.all_shifts">
                        <h3>Allways available</h3>
                        <v-icon v-if="roleplayer.all_shifts">done</v-icon>
                        <v-icon v-if="!roleplayer.all_shifts">clear</v-icon>
                    </v-flex>
                    <v-flex xs12 md6 v-if="roleplayer.shifts && !roleplayer.all_shifts">
                        <h3>Shifts</h3>
                        <v-list>
                            <v-list-tile v-for="shift in roleplayer.shifts" :key="shift.start_time">
                                <v-list-tile-content>
                                    <p>{{shift.start_time.slice(0,16).replace("T", " ")}} -
                                        {{shift.end_time.slice(0,16).replace("T", " ")}}</p>
                                </v-list-tile-content>
                            </v-list-tile>
                        </v-list>
                    </v-flex>
                    <v-flex xs12 md8 v-if="roleplayer.others">
                        <h3>Other Information</h3>
                        <p>
                            <pre>{{roleplayer.others}}</pre>
                        </p>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-content>
        <v-snackbar v-model="notExists" :right="true">
            Roleplayer can't be loaded.
            <v-btn color="pink" flat @click="notExists = false">
                Close
            </v-btn>
        </v-snackbar>
    </div>
</template>

<script>
    import Navbar from '@/components/Navbar.vue'
    import axios from 'axios';
    axios.defaults.baseURL = process.env.VUE_APP_BACKEND_URL;

    export default {
        data() {
            return {
                roleplayer: {
                    id: '',
                    prename: '',
                    name: '',
                    gender: '',
                    nationality: '',
                    age: null,
                    exercise_id: this.$route.params.e_id,
                    others: '',
                    all_shifts: '',
                    shifts: [],
                    modules: []
                },
                notExists: false
            }
        },
        components: {
            Navbar
        },
        methods: {
            loadRoleplayer() {
                var exerciseID = this.$route.params.e_id
                var roleplayerID = this.$route.params.id
                axios.get('/exercises/' + exerciseID + '/roleplayers/' + roleplayerID).then(response => {
                    this.roleplayer = response.data
                }).catch(error => {
                    this.notExists = true
                })
            }
        },
        mounted() {
            this.loadRoleplayer();
        }
    }
</script>
<style>
    pre {
        font-family: Roboto, sans-serif;
        white-space: pre-wrap;
        /* css-3 */
        white-space: -moz-pre-wrap;
        /* Mozilla, since 1999 */
        white-space: -pre-wrap;
        /* Opera 4-6 */
        white-space: -o-pre-wrap;
        /* Opera 7 */
        word-wrap: break-word;
        /* Internet Explorer 5.5+ */
    }
</style>